import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e027243a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "emoji-panel-wrapper" }
const _hoisted_2 = { key: "open" }
const _hoisted_3 = { key: "close" }


const __default__ = {
  name: 'CreateFileName'
}

import { ref, watchEffect } from 'vue'
import { NInput, NPopover, PopoverInst } from 'naive-ui'
import Icon from '@teams/common/components/icon'
import EmojiPanel from '@/components/emojiPanel/Index.vue'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    nameOption: null,
    maxlength: { default: 256 }
  },
  emits: ["update"],
  setup(__props: any, { emit: emits }: { emit: ({
  (
    e: 'update',
    context: {
      icon?: string
      name?: string
      autoUpdate: boolean
    }
  ): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { nameOption: {
      defaultIcon: string
      defaultName: string
      icon: string
      name: string
      autoUpdate: boolean
    }, maxlength: number }




const emojiPopoverRef = ref<PopoverInst>()
const form = ref<{ icon: string; name: string; autoUpdate: boolean }>({
  icon: '',
  name: '',
  autoUpdate: false
})
const isFocus = ref(false)

watchEffect(() => {
  const { icon, name, autoUpdate } = props.nameOption
  form.value = {
    icon,
    name,
    autoUpdate
  }
})
const update = (params: { icon?: string; name?: string }) => {
  emits('update', {
    ...params,
    autoUpdate: form.value.autoUpdate
  })
}
// 监听popover显示标记图标选中背景状态
const popoverShowFlag = ref(false)
const popoverShow = value => {
  popoverShowFlag.value = value
}
const selectIcon = (icon: string) => {
  form.value.icon = icon
  form.value.autoUpdate = false
  emojiPopoverRef.value?.setShow(false)
  update({ icon: icon })
  popoverShowFlag.value = false
}
// 自动生成图标名称
const autoCreate = () => {
  if (form.value.autoUpdate) {
    return
  }
  const { defaultName, defaultIcon } = props.nameOption
  form.value.autoUpdate = true
  form.value.icon = defaultIcon
  form.value.name = defaultName
  update({
    icon: form.value.icon,
    name: form.value.name
  })
}
const handleFocus = (e: FocusEvent) => {
  // 自动全选
  ;(e.target as HTMLInputElement).select()
  isFocus.value = true
}
const handleBlur = () => {
  // 输入框失焦时，如果为空用回标签名字
  isFocus.value = false
  const { name: initialName, autoUpdate: initialAutoUpdate } = props.nameOption
  const { name, autoUpdate } = form.value
  if (!name) {
    form.value.name = initialName
    form.value.autoUpdate = initialAutoUpdate
    return
  }
  if (name === initialName && autoUpdate === initialAutoUpdate) {
    return
  }
  update({
    name
  })
}
const handleInput = () => {
  form.value.autoUpdate = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["name-input", { 'name-input--italic': form.value.autoUpdate && !isFocus.value }])
  }, [
    _createVNode(_unref(NInput), {
      value: form.value.name,
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.name) = $event)),
      placeholder: "请输入",
      onBlur: handleBlur,
      onFocus: handleFocus,
      onInput: handleInput,
      size: "large",
      maxlength: __props.maxlength
    }, {
      prefix: _withCtx(() => [
        _createVNode(_unref(NPopover), {
          placement: "bottom",
          trigger: "click",
          "on-update:show": popoverShow,
          ref_key: "emojiPopoverRef",
          ref: emojiPopoverRef,
          class: "emoji-popover"
        }, {
          trigger: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["emoji-popover__trigger", popoverShowFlag.value ? 'emoji-popover__trigger__click' : ''])
            }, [
              _createElementVNode("span", null, _toDisplayString(form.value.icon), 1)
            ], 2)
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(EmojiPanel, {
                onSelect: selectIcon,
                selectIcon: form.value.icon
              }, null, 8, ["selectIcon"])
            ])
          ]),
          _: 1
        }, 512)
      ]),
      suffix: _withCtx(() => [
        _createElementVNode("div", {
          class: "name-input__suffix",
          onClick: autoCreate
        }, [
          _createVNode(_unref(NPopover), {
            trigger: "hover",
            class: "name-input__suffix-tip"
          }, {
            trigger: _withCtx(() => [
              (form.value.autoUpdate)
                ? (_openBlock(), _createBlock(_unref(Icon), {
                    key: "autoOpen",
                    name: "autoOpen",
                    size: 16
                  }))
                : (_openBlock(), _createBlock(_unref(Icon), {
                    key: "autoClose",
                    name: "autoClose",
                    size: 16
                  }))
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                (form.value.autoUpdate)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, "已开启：根据标签页内容自动命名"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_3, "点击开启：根据标签页内容自动命名"))
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["value", "maxlength"])
  ], 2))
}
}

})